export const validateLettersAndNumbersOnly = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  event.target.value = event.target.value.replace(
    /[^a-zA-Z0-9\u05D0-\u05EA\- '"\n]/g,
    ''
  );
};

export const validateLettersOnly = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  event.target.value = event.target.value.replace(
    /[^a-zA-Z\s\u05D0-\u05EA]/g,
    ''
  );
};

export const validateHebrewLettersOnly = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  event.target.value = event.target.value.replace(/[^\u05D0-\u05EA\s]/g, '');
};

export const validateEnglishLettersOnly = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  event.target.value = event.target.value.replace(/[^a-zA-Z\s]/g, '');
};

export const validateStringNumbersOnly = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  event.target.value = event.target.value.replace(/[^0-9]/g, '');
};

export const validateModRelativeDetail = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  event.target.value = event.target.value.replace(/[^-0-9a-zA-Zא-ת\" ']/g, '');
};
